import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an unhandled rendering error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="d-flex align-items-center justify-content-center w-100"
          style={{ minHeight: '400px', padding: '30px' }}
        >
          <div
            className="card text-center shadow-sm p-5"
            style={{
              maxWidth: '500px',
              borderRadius: '12px',
              border: '1px solid #e2e8f0',
              backgroundColor: '#fff'
            }}
          >
            <div className="mb-4">
              <i
                className="feather icon-alert-triangle text-warning"
                style={{ fontSize: '48px', color: '#ffb300' }}
              />
            </div>
            <h4
              className="mb-3"
              style={{
                fontFamily: "'Inter', sans-serif",
                fontWeight: '700',
                color: '#212121'
              }}
            >
              Something went wrong
            </h4>
            <p
              className="text-muted mb-4"
              style={{ fontSize: '14px', lineHeight: '1.6' }}
            >
              An unexpected error occurred while rendering this page. The system administrator has been notified.
            </p>
            <button
              className="btn btn-primary"
              onClick={this.handleReset}
              style={{
                backgroundColor: '#005457',
                borderColor: '#005457',
                borderRadius: '8px',
                padding: '10px 24px',
                fontWeight: '600',
                fontSize: '13px'
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default ErrorBoundary;
